import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'

export const Title = styled.h1<any>`
  color: var(--text);
  font-size: 28px;
  text-align: center;
  margin: 0 0 2rem 0;
  line-height: 1.3;

  sup {
    font-size: 12px;
    margin-left: 5px;
    position: relative;
    top: -5px;
  }

  @media ${breakpoint.desktop} {
    margin: 3rem 0;
    text-align: ${props => props.center ? 'center' : 'left'};
    font-size: 48px;

    sup {
      font-size: 18px;
    }
  }

  @media print {
    font-size: 36px;
  }
`

export const Subtitle = styled.h2<any>`
  font-size: 22px;
  margin: 0 0 1rem;
  text-align: center;

  @media ${breakpoint.desktop} {
    margin-bottom: 0;
    text-align: left;
  }

  sup {
    font-size: 12px;
  }
`